import { render } from "./FolderManagement.vue?vue&type=template&id=04de16a8&scoped=true"
import script from "./FolderManagement.vue?vue&type=script&lang=js"
export * from "./FolderManagement.vue?vue&type=script&lang=js"

import "./FolderManagement.vue?vue&type=style&index=0&id=04de16a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04de16a8"]])

export default __exports__